import uiTemplateList from './uiTemplateList.js';
import bootstrapTemplateList from './bootstrapTemplateList.js';
import tailwindcssTemplateList from './tailwindcssTemplateList.js';
import jsTemplateList from './jsTemplateList.js';
import reactTemplateList from './reactTemplateList.js';

const projectsInfo = {
  React: reactTemplateList,
  UI: uiTemplateList,
  Tailwind: tailwindcssTemplateList,
  Bootstrap: bootstrapTemplateList,
  Js: jsTemplateList,
};

export default projectsInfo;
